import HeroSection from './components/HeroSection';
import HowWeWorkSection from './components/HowWeWorkSection';
import CoreServicesSection from './components/CoreServicesSection';
import WhatSessionLooksLikeSection from './components/WhatSessionLooksLikeSection';
import WhyChooseNirvaSection from './components/WhyChooseNirvaSection';
import FaqsSection from '../../../components/ServicesFaq';
import { Gapper } from '../../../ui/utils';
import { START_VIDEO_CONSULTATION } from './constants';
import StartVideoConsultation from '../../../components/StartVideoConsultation';
import { PageWrapper } from '../../../components/Layouts/PageWrapper';
import WhoWeServeSection from './components/WhoWeServeSection';

const Services = () => {
  return (
    <PageWrapper>
      <Gapper gap={100}>
        <HeroSection />
        <HowWeWorkSection />
        <CoreServicesSection />
        <WhatSessionLooksLikeSection />
        <WhyChooseNirvaSection />
        <WhoWeServeSection />
        <FaqsSection />
        <StartVideoConsultation
          bgImg={START_VIDEO_CONSULTATION.backgroundImage}
          title={START_VIDEO_CONSULTATION.title}
          subtitle={START_VIDEO_CONSULTATION.subtitle}
          btnText={START_VIDEO_CONSULTATION.buttonText}
        />
      </Gapper>
    </PageWrapper>
  );
};

export default Services;
